import styled from "@emotion/styled";
import React from "react";
import { Typography } from "../Typography";
import { theme } from "../theme";
import { StatusVariant } from "@ecologi/shared";
import { Status } from "@ecologi/shared";

const variantBackgroundColorMap: Record<StatusVariant, string> = {
  bold: theme.colors.charcoal,
  info: theme.colors.mist,
  warning: theme.colors.roseLight,
};

const variantTextColorMap: Record<StatusVariant, string> = {
  bold: theme.colors.snowdrop,
  info: theme.colors.charcoal,
  warning: theme.colors.charcoal,
};

const StyledTypography = styled(Typography)<{ variant: StatusVariant }>(
  ({ variant }) => ({
    backgroundColor: variantBackgroundColorMap[variant],
    color: variantTextColorMap[variant],
    borderRadius: "40px",
    padding: "6px 12px",
  })
);

export const StatusTag = ({ label, variant }: Status) => {
  return (
    <StyledTypography
      use="dashboardMicroCopyRegular"
      as="strong"
      variant={variant}
    >
      {label}
    </StyledTypography>
  );
};
